"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = require("@twii/core/lib/Context");
var UserServiceContext = new Context_1.Context();
exports.UserServiceContext = UserServiceContext;
